import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, UncontrolledTooltip } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { IScreenStatus } from "../../app/models/screens";
import { RootStoreContext } from "../../app/stores/rootStore";
import GenericConfirmModal from "../common/GenericConfirmModal";

interface IParams {
  screen: IScreenStatus;
}

export const ScreenDisconnectButton: React.FC<IParams> = ({ screen }) => {
  const rootStore = useContext(RootStoreContext);
  const { deleteScreenConnection } = rootStore.screensStore;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [t] = useTranslation(["browse_page", "translation"], translationHookOptions);

  return (
    <>
      <Button
        id={`btnDisconnect_${screen.id}`}
        color="none"
        onClick={() => setIsModalOpen(true)}
        className="screenListButton"
      >
        <i className="fas fa-trash-alt fa-2x text-danger iconBoxList"></i>
      </Button>
      <UncontrolledTooltip
        delay={0}
        placement="left"
        target={`btnDisconnect_${screen.id}`}
      >
        {t("screens_modal_table_disconnect_button")}
      </UncontrolledTooltip>
      <GenericConfirmModal
        title={t("screens_modal_table_disconnect_title")}
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        action={() => {
          deleteScreenConnection(screen.id);
        }}
        messages={t("screens_modal_table_disconnect_confirmation")}
      />
    </>
  );
};

export default observer(ScreenDisconnectButton);
